// extracted by mini-css-extract-plugin
module.exports = {"game":"Landing_game__3XX-Z","hero":"Landing_hero__3e-gw"};